import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { LanguageOptions } from '../../entities/LanguageOptions';
import { toast } from 'react-toastify';
import { UploadIcon } from '../../features/UploadIcon';
import { Form, Row, Col } from 'react-bootstrap';
import { FormLayout, FormSection, FormField } from '../../shared/ui/FormLayout';

const CreateCountriesGroupPage = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [icon, setIcon] = useState(null);
  const [form, setForm] = useState({ title: '', mainLanguageId: 1 });

  const handleSubmit = async () => {
    if (!form.title.trim()) { toast.error('Введите название'); return; }
    setSaving(true);
    try {
      const formData = new FormData();
      if (icon) formData.append('mainImg', icon);
      formData.append('model', JSON.stringify({ Title: form.title, LanguageEntityId: Number(form.mainLanguageId) }));
      await apiRequests.countriesGroups.create(formData);
      toast.success('Группа стран создана');
      navigate('/general/countriesGroups');
    } catch { toast.error('Ошибка'); } finally { setSaving(false); }
  };

  return (
    <FormLayout onSubmit={handleSubmit} onBack={() => navigate('/general/countriesGroups')} saving={saving} submitText="Создать">
      <FormSection title="Основная информация">
        <Row>
          <Col md={6}>
            <FormField label="Название" required>
              <Form.Control type="text" value={form.title} onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))} placeholder="Группа стран" />
            </FormField>
          </Col>
          <Col md={6}>
            <LanguageOptions label="Основной язык" onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: Number(val) }))} />
          </Col>
        </Row>
        <UploadIcon onSelect={setIcon} entityType="countriesGroup" />
      </FormSection>
    </FormLayout>
  );
};

export default CreateCountriesGroupPage;
